  (function () {
    if (window.__rrSwatchInit) return;
    window.__rrSwatchInit = true;

    function swatchLabel(container) {
      var p = container.previousElementSibling;
      return p && p.querySelector('[data-rr-swatch-label]');
    }

    function selected(container) {
      return container.querySelector('.rr-card__swatch.is-active');
    }

    function captureOriginalImage(img) {
      if (!img || img.dataset.rrSwatchCaptured === 'true') return;
      img.dataset.rrSwatchCaptured = 'true';
      img.dataset.rrOriginalSrc = img.getAttribute('src') || '';
      img.dataset.rrOriginalSrcset = img.getAttribute('srcset') || '';
      img.dataset.rrOriginalAlt = img.getAttribute('alt') || '';
    }

    function restoreOriginalImage(img) {
      if (!img) return;
      captureOriginalImage(img);
      if (img.dataset.rrOriginalSrc) img.setAttribute('src', img.dataset.rrOriginalSrc);
      if (img.dataset.rrOriginalSrcset) {
        img.setAttribute('srcset', img.dataset.rrOriginalSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      img.setAttribute('alt', img.dataset.rrOriginalAlt || '');
    }

    function applySwatchImage(img, swatch, restoreOnNoImage) {
      if (!img) return;
      captureOriginalImage(img);

      if (!swatch) {
        restoreOriginalImage(img);
        return;
      }
      if (!swatch.dataset.swatchImg) {
        // No image for this swatch (hidden variant image).
        // On hover: keep the card's current image — don't jump to original.
        // On mouseout revert: restore to the selected swatch's image (pass restoreOnNoImage=true).
        if (restoreOnNoImage) restoreOriginalImage(img);
        return;
      }

      img.setAttribute('src', swatch.dataset.swatchImg);
      if (swatch.dataset.swatchSrcset) {
        img.setAttribute('srcset', swatch.dataset.swatchSrcset);
      } else {
        img.removeAttribute('srcset');
      }
      if (swatch.dataset.swatchAlt) img.setAttribute('alt', swatch.dataset.swatchAlt);
    }

    /* Hover — preview the swatch's product image and update the label.
       Does NOT change is-active; that is only changed on click. */
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest('.rr-card__swatch');
      if (!sw) return;
      var card = sw.closest('.rr-card');
      if (!card) return;
      var img = card.querySelector('[data-rr-card-primary-image], .rr-card__image-wrap img');
      applySwatchImage(img, sw);
      var container = sw.closest('[data-rr-swatches]');
      var lbl = swatchLabel(container);
      if (lbl) lbl.textContent = sw.dataset.swatchLabel || '';
    });

    /* Mouseout — revert card image and label to the currently selected swatch.
       Leaving is-active untouched here prevents any double-ring state. */
    document.addEventListener('mouseout', function (e) {
      var sw = e.target.closest('.rr-card__swatch');
      if (!sw) return;
      var card = sw.closest('.rr-card');
      if (!card) return;
      if (card.querySelector('.rr-card__swatch:hover')) return;
      var container = sw.closest('[data-rr-swatches]');
      var sel = selected(container);
      var img = card.querySelector('[data-rr-card-primary-image], .rr-card__image-wrap img');
      applySwatchImage(img, sel, true);
      var lbl = swatchLabel(container);
      if (lbl) lbl.textContent = (sel && sel.dataset.swatchLabel) || '';
    });

    /* Click — permanently select this swatch, swap the card image, update label.
       Prevents the parent <a> from navigating. */
    document.addEventListener('click', function (e) {
      var sw = e.target.closest('.rr-card__swatch');
      if (!sw) return;
      e.preventDefault();
      e.stopPropagation();
      var container = sw.closest('[data-rr-swatches]');
      container.querySelectorAll('.rr-card__swatch').forEach(function (s) {
        s.classList.remove('is-active');
        s.setAttribute('aria-pressed', 'false');
      });
      sw.classList.add('is-active');
      sw.setAttribute('aria-pressed', 'true');
      var card = sw.closest('.rr-card');
      var img = card && card.querySelector('[data-rr-card-primary-image], .rr-card__image-wrap img');
      applySwatchImage(img, sw);
      var gallery = card && card.querySelector('[data-rr-card-gallery]');
      if (gallery) gallery.scrollTo({ left: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      var lbl = swatchLabel(container);
      if (lbl) lbl.textContent = sw.dataset.swatchLabel || '';
    });
  })();

(function () {
  if (window.RRProductCards) return;
  function init(root) {
    root.querySelectorAll('[data-rr-card-gallery]').forEach(function (gallery) {
      if (gallery.dataset.rrGalleryBound === '1') return;
      gallery.dataset.rrGalleryBound = '1';
      var current = gallery.parentElement.querySelector('[data-rr-gallery-current]');
      var framePending = false;
      function update() {
        framePending = false;
        if (!current || !gallery.clientWidth) return;
        var slides = gallery.querySelectorAll('.rr-card__image-slide');
        var index = Math.round(gallery.scrollLeft / gallery.clientWidth);
        current.textContent = String(Math.max(0, Math.min(slides.length - 1, index)) + 1);
      }
      gallery.addEventListener('scroll', function () {
        if (framePending) return;
        framePending = true;
        window.requestAnimationFrame(update);
      }, { passive: true });
    });
  }
  window.RRProductCards = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
